export interface SelectedExtraResponse {
  Id: string;
  Amount?: number | null;
  AnnualOptionalBenefit?: number;
  MonthlyOptionalBenefit?: number;
}

export type SelectedExtraInput = string | SelectedExtraResponse;
export type SelectedExtrasInput =
  | SelectedExtraInput
  | SelectedExtraInput[]
  | null
  | undefined;

export const normalizeSelectedExtrasToIds = (
  selectedExtras: unknown,
): string[] => {
  if (selectedExtras === null || selectedExtras === undefined) {
    return [];
  }

  const extras = Array.isArray(selectedExtras)
    ? selectedExtras
    : [selectedExtras];

  return extras.flatMap((extra) => {
    if (typeof extra === 'string') {
      return extra ? [extra] : [];
    }

    if (
      typeof extra === 'object' &&
      extra !== null &&
      'Id' in extra &&
      typeof extra.Id === 'string' &&
      extra.Id
    ) {
      return [extra.Id];
    }

    return [];
  });
};

export const normalizeSelectedExtrasForCreateOrUpdate = (
  selectedExtras: SelectedExtrasInput,
  isEquine: boolean,
) => {
  if (selectedExtras === null || selectedExtras === undefined) {
    return selectedExtras;
  }

  const extras = Array.isArray(selectedExtras)
    ? selectedExtras
    : [selectedExtras];

  if (!extras.length) {
    return extras;
  }

  if (isEquine) {
    return extras.map((extra) =>
      typeof extra === 'string'
        ? {
            Id: extra,
            Amount: 1,
          }
        : extra,
    );
  }

  // GetQuote returns cat/dog/rabbit extras as benefit objects, while the
  // standard CreateOrUpdate endpoint expects an array of extra IDs.
  return normalizeSelectedExtrasToIds(extras);
};
